import axios from 'axios';
import * as Config from '../../config';

const state = { };

const actions = {
    openai_sendIntencion({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'openai/captar-intencion', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    openai_getLogs() {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'openai/get-logs')
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    openai_updateChat({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'openai/update-chat', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    }
}

const mutations = {

};

export default {
    state,
    actions,
    mutations
};